import React from 'react'
import { connect } from 'react-redux'
import Autosuggest from 'react-autosuggest'

import FindMyLocationControl from './FindMyLocationControl'

import {
  selectTideStation,
  updateLocationSearch,
  clearLocationSearch,
} from '../../actions/uiActions'

import {
  visitedTideStationsSelector,
  locationSearchQuerySelector,
  locationSearchHasFocusSelector,
} from '../../reducers/uiReducer'

import NOAATides from '../../services/NOAATides'
import GoogleMaps from '../../services/google-maps-api'

import styles from './LocationSearch.autosuggest.module.css'
import iconClose from '../../assets/images/icon-close.svg'










// ===================
// = Get suggestions =
// ===================

const stations2Suggestions = (stations) => {
  return stations.map(station => {
    return {
      id:    station.stationId,
      value: station.name,
      type:  'stationSuggestion'
    }
  })
}

const getRecentSuggestions = (visitedStations, query, callback) => {
  const queryRegex = new RegExp(query, 'gi')
  const stations = visitedStations.filter(station => {
    return station.name.match(queryRegex)
  }).slice(0, 10)

  const suggestions = stations2Suggestions(stations)

  callback.call(null, suggestions)
}

const getStationSuggestions = (query, callback) => {
  if (query.trim().length === 0)
    callback.call(null, [])
  else {
    const stations = NOAATides.getStations({filterBy: query}).slice(0, 3)
    const suggestions = stations2Suggestions(stations)

    callback.call(null, suggestions)
  }
}

const getPlaceSuggestions = (query, callback) => {
  if (query.trim().length === 0)
    callback.call(null, [])
  else {
    GoogleMaps.getRegions(query, (response, responseStatus) => {
      let suggestions = []

      if (responseStatus === GoogleMaps.PlacesServiceStatus.OK) {
        const places = response.slice(0, 3)
        suggestions = places.map(place => {
          return {
            id:    place.place_id,
            value: place.description,
            type:  'placeSuggestion'
          }
        })
      }

      callback.call(null, suggestions)
    })
  }
}

const getNaturalFeatureSuggestions = (query, callback) => {
  if (query.trim().length === 0)
    callback.call(null, [])
  else {
    GoogleMaps.getNaturalFeatures(query, (response, responseStatus) => {
      let suggestions = []

      if (responseStatus === GoogleMaps.PlacesServiceStatus.OK) {
        const places = response
        suggestions = places.map(place => {
          return {
            id:    place.place_id,
            value: place.formatted_address,
            type:  'naturalFeatureSuggestion'
          }
        })
      }

      callback.call(null, suggestions)
    })
  }
}











// ======================
// = Format suggestions =
// ======================

const renderSectionTitle = (section) => {
  return section.title
}

const getSectionSuggestions = (section) => {
  return section.suggestions
}

const getSuggestionValue = (suggestion) => {
  return suggestion.value
}

const renderSuggestion = (suggestion, { query, isHighlighted }) => {
  return suggestion.value
}













// ============================
// = LocationSearch Component =
// ============================
//
// A wrapper component for the react-autosuggest component
// (see docs https://github.com/moroshko/react-autosuggest)

class LocationSearch extends React.Component {

  constructor(props) {
    super(props)

    this.allRecentSuggestions = stations2Suggestions(props.visitedStations)

    this.state = {
      recentSuggestions: this.allRecentSuggestions,
      stationSuggestions: [],
      placeSuggestions: [],
      naturalFeatureSuggestions: []
    }
  }

  componentWillReceiveProps(nextProps) {
    this.allRecentSuggests = stations2Suggestions(nextProps.visitedStations)
  }




  clearSuggestions() {
    this.setState({
      recentSuggestions: this.allRecentSuggestions,
      stationSuggestions: [],
      placeSuggestions: [],
      naturalFeatureSuggestions: []
    })
  }

  onClickClear = (e) => {
    const { query, clearQuery } = this.props

    clearQuery()
    this.clearSuggestions()

    if (query.length !== 0) {
      this.inputElement.focus()
      setTimeout(()=>this.inputElement.focus())
    }
  }


  // ========================================
  // = Autosuggest component event handlers =
  // ========================================

  onInputChange = (e, { newValue }) => {
    this.props.updateQuery(newValue)
  }

  onInputFocus = (e) => {
    this.props.updateHasFocus(true)
  }

  onInputBlur = (e) => {
    this.props.updateHasFocus(false)
  }

  onSuggestionsFetchRequested = ({value, reason}) => {
    const { visitedStations } = this.props

    getRecentSuggestions(visitedStations, value, (suggestions) => {
      this.setState({
        recentSuggestions: suggestions
      })
    })
    getStationSuggestions(value, (suggestions) => {
      this.setState({
        stationSuggestions: suggestions
      })
    })
    getPlaceSuggestions(value, (suggestions) => {
      this.setState({
        placeSuggestions: suggestions
      })
    })
    // getNaturalFeatureSuggestions(value, (suggestions) => {
    //   this.setState({
    //     naturalFeatureSuggestions: suggestions
    //   })
    // })
  }

  onSuggestionsClearRequested = () => {
    this.clearSuggestions()
  }

  onSuggestionSelected = (e, { suggestion, method }) => {
    const { selectTideStation } = this.props

    switch (suggestion.type) {
    case 'stationSuggestion':
      selectTideStation(suggestion.id)
      break;
    case 'placeSuggestion':
    case 'naturalFeatureSuggestion':
      GoogleMaps.geocode(suggestion.id, (res, statusCode) => {
        const latlng = res[0].geometry.location
        const station = NOAATides.getClosestStation(latlng)
        selectTideStation(station.stationId)
      })
      break;
    default:
    }

    this.inputElement.blur()
  }

  renderInputComponent = (inputProps) => {
    const { query, hasFocus } = this.props

    const shouldShowCancelButton = query.length > 0 || hasFocus

    let className = styles.inputContainer
    if (hasFocus)
      className += ' ' + styles.hasFocus

    return (
      <div className={className}>
        <FindMyLocationControl styles={styles} />
        <input {...inputProps} />
        { shouldShowCancelButton &&
          <a
            className={styles.inputClear}
            onClick={this.onClickClear}
            ripple=''
          >
            <img src={iconClose} />
          </a>
        }
      </div>
    )
  };






  render() {
    const {
      recentSuggestions,
      stationSuggestions,
      placeSuggestions,
      naturalFeatureSuggestions,
    } = this.state
    const {
      query,
      autoFocus
    } = this.props




    // Combine various suggestion types into one results array
    const suggestions = []
    if (recentSuggestions.length > 0){
      suggestions.push({
        title: 'Recent',
        suggestions: recentSuggestions
      })
    }
    const filteredStationSuggestions = stationSuggestions.filter(station => {
      return !recentSuggestions.some(recent => {
        return station.id === recent.id
      })
    })
    if (filteredStationSuggestions.length > 0) {
      suggestions.push({
        title: 'Tide stations',
        suggestions: filteredStationSuggestions
      })
    }
    if (placeSuggestions.length > 0 || naturalFeatureSuggestions.length > 0) {
      suggestions.push({
        title: 'Places',
        suggestions: [].concat(naturalFeatureSuggestions, placeSuggestions)
      })
    }



    // Properties to give to the input element
    const inputProps = {
      placeholder: 'Search by place or tide station',
      value: query,
      onChange: this.onInputChange,
      onFocus: this.onInputFocus,
      onBlur: this.onInputBlur,
      autoFocus,
    }


    return (
      <Autosuggest
        ref={e => this.inputElement = (e && e.input)}
        // alwaysRenderSuggestions={true}
        shouldRenderSuggestions={()=>true}
        suggestions={suggestions}
        renderInputComponent={this.renderInputComponent}
        renderSectionTitle={renderSectionTitle}
        getSectionSuggestions={getSectionSuggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        onSuggestionSelected={this.onSuggestionSelected}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
        theme={styles}
        focusInputOnSuggestionClick={false}
        multiSection={true}
      />
    )
  }
}



export default connect(
  (state) => {
    return {
      visitedStations: visitedTideStationsSelector(state),
      query: locationSearchQuerySelector(state),
      hasFocus: locationSearchHasFocusSelector(state),
    }
  },
  (dispatch) => {
    return {
      selectTideStation: (tideStation) => {
        dispatch(selectTideStation(tideStation))
      },
      updateQuery: (query) => {
        dispatch(updateLocationSearch({query}))
      },
      clearQuery: () => {
        dispatch(clearLocationSearch())
      },
      updateHasFocus: (hasFocus) => {
        dispatch(updateLocationSearch({hasFocus}))
      },
    }
  }
)(LocationSearch)



// WEBPACK FOOTER //
// ./src/components/LocationSearch/index.js